import React, { Component } from "react";
import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavbarToggler,
  MDBCollapse,
  MDBJumbotron,
} from "mdbreact";

import { Link } from "react-scroll";

class Navbar extends Component {
  state = {
    isOpen: false,
  };

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return (
      <MDBJumbotron className="container-navbar w-100 sticky-top">
        <MDBNavbar dark expand="xl">
          <MDBNavbarBrand>
            <strong className="white-text pl-2">EBENEZER</strong>
          </MDBNavbarBrand>
          <MDBNavbarToggler onClick={this.toggleCollapse} />
          <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
            <MDBNavbarNav right>
              <MDBNavItem active>
                <Link
                  activeClass="active"
                  spy={true}
                  smooth={true}
                  offset={this.state.isOpen ? -225 : 0}
                  duration={500}
                  to="sale"
                  className="nav-link"
                >
                  APARTAMENTOS EN VENTA
                </Link>
              </MDBNavItem>
              <MDBNavItem>
                <Link
                  activeClass="active"
                  spy={true}
                  smooth={true}
                  offset={this.state.isOpen ? -225 : 0}
                  duration={500}
                  to="project"
                  className="nav-link"
                >
                  PROYECTOS REALIZADOS
                </Link>
              </MDBNavItem>
              <MDBNavItem>
                <Link
                  activeClass="active"
                  spy={true}
                  smooth={true}
                  offset={this.state.isOpen ? -225 : 0}
                  duration={500}
                  to="service"
                  className="nav-link"
                >
                  NUESTROS SERVICIOS
                </Link>
              </MDBNavItem>
              <MDBNavItem>
                <Link
                  activeClass="active"
                  spy={true}
                  smooth={true}
                  offset={this.state.isOpen ? -225 : 0}
                  duration={500}
                  to="aboutus"
                  className="nav-link"
                >
                  QUIÉNES SOMOS
                </Link>
              </MDBNavItem>
              <MDBNavItem>
                <Link
                  activeClass="active"
                  spy={true}
                  smooth={true}
                  offset={this.state.isOpen ? -225 : 0}
                  duration={500}
                  to="contact"
                  className="nav-link"
                >
                  CONTACTANOS
                </Link>
              </MDBNavItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBNavbar>
      </MDBJumbotron>
    );
  }
}

export default Navbar;
